export default __webpack_public_path__ + "static/media/covid.0614dae5.jpeg";